import axios from 'axios';

export const libraryService = {
    /** Goals */
    createLibraryGoalService: (body) => axios.post(`/clinical/library/goals`, body, { auth: true }),

    editLibraryGoalService: (id, body) => axios.patch(`/clinical/library/goals/${id}`, body, { auth: true }),

    deleteLibraryGoalService: (id) => axios.delete(`/clinical/library/goals/${id}`, { auth: true }),

    cloneLibraryGoalService: (id, params) => axios.post(`/clinical/library/goals/${id}/clone`, params || {}, { auth: true }),

    getLibraryGoalsService: (params) => axios.get(`/clinical/library/goals`, { auth: true, params: { ...params } }),

    getLibraryGoalByIdService: (id) => axios.get(`/clinical/library/goals/${id}`, { auth: true }),

    upsertLibrarySectionDescriptionBlockService: (goalId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/section-description-block`, body, { auth: true }),

    deleteLibrarySectionDescriptionBlockService: (goalId, sectionTypeId) =>
        axios.delete(`/clinical/library/goals/${goalId}/section-description-block/${sectionTypeId}`, { auth: true }),

    createLibraryGoalTargetService: (goalId, body) => axios.post(`/clinical/library/goals/${goalId}/target`, body, { auth: true }),

    editLibraryGoalTargetService: (goalId, targetId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/target/${targetId}`, body, { auth: true }),

    deleteLibraryGoalTargetService: (goalId, targetId) =>
        axios.delete(`/clinical/library/goals/${goalId}/target/${targetId}`, { auth: true }),

    reorderLibraryGoalTargetService: (goalId, reorder) =>
        axios.patch(`/clinical/library/goals/${goalId}/reorder/targets`, reorder, { auth: true }),

    chooseTargetsFromLibraryGoalService: (goalId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/copy/targets`, body, {
            auth: true,
        }),

    createLibraryGoalOptionService: (goalId, body) => axios.post(`/clinical/library/goals/${goalId}/option`, body, { auth: true }),

    editLibraryGoalOptionService: (goalId, targetId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/option/${targetId}`, body, { auth: true }),

    deleteLibraryGoalOptionService: (goalId, targetId) =>
        axios.delete(`/clinical/library/goals/${goalId}/option/${targetId}`, { auth: true }),

    reorderLibraryGoalOptionService: (goalId, reorder) =>
        axios.patch(`/clinical/library/goals/${goalId}/reorder/options`, reorder, { auth: true }),

    chooseOptionsFromLibraryGoalService: (goalId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/copy/options`, body, {
            auth: true,
        }),
    /** End */

    /** Mastery */

    changeLibraryGoalTargetMasteryService: (goalId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/targets/mastery`, body, { auth: true }),

    changeLibraryGoalMasteryService: (goalId, body) => axios.patch(`/clinical/library/goals/${goalId}/goal/mastery`, body, { auth: true }),

    changeSingleLibraryGoalTargetMasteryService: (goalId, targetId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/target/${targetId}/mastery`, body, { auth: true }),

    removeSingleLibraryGoalTargetMasteryService: (goalId, targetId) =>
        axios.patch(`/clinical/library/goals/${goalId}/target/${targetId}/mastery/setDefault`, {}, { auth: true }),

    /** End */

    /** Target Maintenance */

    changeLibraryTargetMaintenanceService: (goalId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/maintenance`, body, { auth: true }),

    addLibraryTargetMaintenanceStepService: (goalId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/maintenance/step`, body, { auth: true }),

    editLibraryTargetMaintenanceStepService: (goalId, stepId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/maintenance/${stepId}`, body, { auth: true }),

    deleteLibraryTargetMaintenanceStepService: (goalId, stepId) =>
        axios.delete(`/clinical/library/goals/${goalId}/maintenance/step/${stepId}`, { auth: true }),

    /** End */

    /** Single Target Maintenance */

    changeSingleLibraryTargetMaintenanceService: (goalId, targetId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/target/${targetId}/maintenance`, body, { auth: true }),

    addSingleLibraryTargetMaintenanceStepService: (goalId, targetId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/target/${targetId}/maintenance/step`, body, { auth: true }),

    editSingleLibraryTargetMaintenanceStepService: (goalId, stepId, body) =>
        axios.patch(`/clinical/library/goals/${goalId}/target/${body?.targetId}/maintenance/${stepId}`, body, { auth: true }),

    deleteSingleLibraryTargetMaintenanceStepService: (goalId, targetId, stepId) =>
        axios.delete(`/clinical/library/goals/${goalId}/target/${targetId}/maintenance/step/${stepId}`, { auth: true }),

    singleLibraryTargetFollowGoalConfigService: (goalId, targetId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/target/${targetId}/maintenance-follow-goal-config`, body, { auth: true }),

    singleLibraryTargetMasteryFollowGoalService: (goalId, targetId, body) =>
        axios.post(`/clinical/library/goals/${goalId}/target/${targetId}/mastery-follow-goal-config`, body, { auth: true }),

    /** End */

    /** Clinical Library Folders */

    getLibraryFoldersService: (params) => axios.get(`/clinical/library/folder`, { auth: true, params: { ...params } }),

    createLibraryFolderService: (body) => axios.post(`/clinical/library/folder`, body, { auth: true }),

    editLibraryFolderService: (id, body) => axios.patch(`/clinical/library/folder/${id}`, body, { auth: true }),

    deleteLibraryFolderService: (id) => axios.delete(`/clinical/library/folder/${id}`, { auth: true }),

    /** End */

    /** Targets */

    createLibraryTargetService: (folderId, body) => axios.post(`/clinical/library/targets/folder/${folderId}`, body, { auth: true }),

    editLibraryTargetService: (folderId, targetId, body) =>
        axios.patch(`/clinical/library/targets/${targetId}/folder/${folderId}`, body, { auth: true }),

    deleteLibraryTargetService: (folderId, targetId) =>
        axios.delete(`/clinical/library/targets/${targetId}/folder/${folderId}`, { auth: true }),

    /** End */

    /** Options */

    createLibraryOptionService: (folderId, body) => axios.post(`/clinical/library/options/folder/${folderId}`, body, { auth: true }),

    editLibraryOptionService: (folderId, targetId, body) =>
        axios.patch(`/clinical/library/options/${targetId}/folder/${folderId}`, body, { auth: true }),

    deleteLibraryOptionService: (folderId, targetId) =>
        axios.delete(`/clinical/library/options/${targetId}/folder/${folderId}`, { auth: true }),

    /** End */
};
